import React, { useEffect, useState } from "react";
import { 
  Card, 
  Row, 
  Col, 
  Badge, 
  Spinner, 
  Container, 
  Form, 
  Button, 
  Dropdown, 
  Modal 
} from "react-bootstrap";
import { createClient } from "@supabase/supabase-js";

// 🔐 Înlocuiește cu datele tale
const supabase = createClient(
  "https://xecpjoetpimjupcoetmp.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhlY3Bqb2V0cGltanVwY29ldG1wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA1MDg4MDIsImV4cCI6MjA2NjA4NDgwMn0.l3mHF5-IsZlYB4LawylJXw3JSgWp2rzIw5GkTlxRRoU"
);

const WebsitesAdminPage = () => {
  const [websites, setWebsites] = useState([]);
  const [loading, setLoading] = useState(true);

  // State pentru formularul de adăugare
  const [formData, setFormData] = useState({
    name: "",
    domain: "",
    technology: "",
    uptime: "",
    last_updated: "",
    owner: ""
  });
  
  // State-uri noi pentru modalul de editare
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingWebsite, setEditingWebsite] = useState(null);

  useEffect(() => {
    fetchWebsites();
  }, []);

  const fetchWebsites = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("websites")
      .select("*")
      .order("last_updated", { ascending: false });
    if (!error) setWebsites(data);
    else console.error("Eroare la preluarea datelor:", error);
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { error } = await supabase.from("websites").insert([formData]);
    if (!error) {
      await fetchWebsites();
      // Resetare formular
      setFormData({ name: "", domain: "", technology: "", uptime: "", last_updated: "", owner: "" });
    } else {
      console.error("Eroare la adăugare:", error);
    }
  };

  // Funcția pentru ștergere
  const handleDelete = async (id) => {
    if (window.confirm("Ești sigur că vrei să ștergi acest website?")) {
      const { error } = await supabase.from("websites").delete().match({ id });
      if (!error) {
        await fetchWebsites();
      } else {
        console.error("Eroare la ștergere:", error);
      }
    }
  };
  
  // Deschide modalul și setează website-ul curent pentru editare
  const handleEditClick = (website) => {
    setEditingWebsite(website);
    setShowEditModal(true);
  };
  
  // Gestionează schimbările în formularul de editare
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditingWebsite(prev => ({ ...prev, [name]: value }));
  };

  // Funcția pentru trimiterea formularului de editare
  const handleUpdate = async (e) => {
    e.preventDefault();
    const { id, ...updateData } = editingWebsite;
    const { error } = await supabase.from("websites").update(updateData).match({ id });
    
    if (!error) {
      setShowEditModal(false);
      setEditingWebsite(null);
      await fetchWebsites();
    } else {
      console.error("Eroare la actualizare:", error);
    }
  };

  return (
    <Container className="py-4">
      <h3 className="mb-4 fw-bold">Website-uri Administrate</h3>

      {/* ========== FORMULARUL DE ADĂUGARE (RESTAURAT) ========== */}
      <Card className="p-4 mb-4 neumorphic-card">
        <h5>Adaugă Website Nou</h5>
        <Form onSubmit={handleSubmit}>
          <Row className="g-2">
            <Col md={4}><Form.Control name="name" placeholder="Nume site" value={formData.name} onChange={handleChange} required /></Col>
            <Col md={4}><Form.Control name="domain" placeholder="Domeniu" value={formData.domain} onChange={handleChange} required /></Col>
            <Col md={4}><Form.Control name="technology" placeholder="Tehnologie" value={formData.technology} onChange={handleChange} /></Col>
            <Col md={3}><Form.Control name="uptime" placeholder="Uptime" value={formData.uptime} onChange={handleChange} /></Col>
            <Col md={3}><Form.Control name="last_updated" type="date" value={formData.last_updated} onChange={handleChange} /></Col>
            <Col md={3}><Form.Control name="owner" placeholder="Client / Proprietar" value={formData.owner} onChange={handleChange} /></Col>
            <Col md={3}><Button type="submit" variant="primary" className="w-100">Adaugă</Button></Col>
          </Row>
        </Form>
      </Card>

      {/* Listare Website-uri */}
      <Row xs={1} md={2} className="g-4">
        {loading ? (
          <div className="text-center w-100"><Spinner animation="border" /></div>
        ) : (
          websites.map((site) => (
            <Col key={site.id}>
              <Card className="shadow-sm border-0 neumorphic-card">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <Card.Title className="fw-semibold mb-2">{site.name}</Card.Title>
                      <div className="text-muted small mb-2">{site.domain}</div>
                    </div>
                    <Dropdown>
                      <Dropdown.Toggle variant="light" size="sm" id="dropdown-basic">
                        ⋮
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item onClick={() => handleEditClick(site)}>Editează</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleDelete(site.id)} className="text-danger">
                          Șterge
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  
                  <div className="d-flex flex-wrap gap-2 mt-2">
                    <Badge bg="light" text="dark">{site.technology}</Badge>
                    <Badge bg="success">{site.uptime}%</Badge>
                    <Badge bg="secondary">actualizat: {new Date(site.last_updated).toLocaleDateString()}</Badge>
                    <Badge bg="primary">{site.owner}</Badge>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))
        )}
      </Row>

      {/* Modal pentru Editare */}
      {editingWebsite && (
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Editează Website</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleUpdate}>
              <Form.Group className="mb-3">
                <Form.Label>Nume site</Form.Label>
                <Form.Control name="name" value={editingWebsite.name} onChange={handleEditChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Domeniu</Form.Label>
                <Form.Control name="domain" value={editingWebsite.domain} onChange={handleEditChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Tehnologie</Form.Label>
                <Form.Control name="technology" value={editingWebsite.technology} onChange={handleEditChange} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Uptime</Form.Label>
                <Form.Control name="uptime" value={editingWebsite.uptime} onChange={handleEditChange} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Ultima actualizare</Form.Label>
                <Form.Control name="last_updated" type="date" value={editingWebsite.last_updated} onChange={handleEditChange} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Client / Proprietar</Form.Label>
                <Form.Control name="owner" value={editingWebsite.owner} onChange={handleEditChange} />
              </Form.Group>
              <Button variant="secondary" onClick={() => setShowEditModal(false)} className="me-2">
                Anulează
              </Button>
              <Button variant="primary" type="submit">
                Salvează Modificările
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      )}
    </Container>
  );
};

export default WebsitesAdminPage;